module.exports = __webpack_public_path__ + "img/register.2c744be5.png";